import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, memo } from 'react';
import { useChartData } from '../context/ChartContext';
import useXYReduce, { XYReducerDomainAxis } from '../hooks/useXYReduce';
import { PathBuilder } from '../utility/PathBuilder';
import { get1DYScale, get2DXScale } from './utilities/scale';
function Top1DChart({ margin: marginProps = 10, data: spectrum, }) {
    const { width, margin: originMargin, xDomain, yDomains, displayerKey, } = useChartData();
    const xyReduce = useXYReduce(XYReducerDomainAxis.XAxis);
    const height = originMargin.top;
    const paths = useMemo(() => {
        if (spectrum) {
            const scaleX = get2DXScale({ width, xDomain, margin: originMargin });
            const scaleY = get1DYScale(yDomains[spectrum.id], height, marginProps);
            const { x, re: y } = spectrum.data;
            const pathPoints = xyReduce({ x, y });
            const pathBuilder = new PathBuilder();
            pathBuilder.moveTo(scaleX(pathPoints.x[0]), scaleY(pathPoints.y[0]));
            for (let i = 1; i < pathPoints.x.length; i++) {
                pathBuilder.lineTo(scaleX(pathPoints.x[i]), scaleY(pathPoints.y[i]));
            }
            return pathBuilder.toString();
        }
        else {
            return undefined;
        }
    }, [
        height,
        marginProps,
        originMargin,
        spectrum,
        width,
        xDomain,
        xyReduce,
        yDomains,
    ]);
    if (!width || !height) {
        return null;
    }
    return (_jsxs("svg", { viewBox: `0 0 ${width} ${height}`, width: width, height: height, children: [_jsx("defs", { children: _jsx("clipPath", { id: `${displayerKey}clip-top`, children: _jsx("rect", { width: width - originMargin.left - originMargin.right, height: height, x: originMargin.left, y: `${0}` }) }) }), _jsx("g", { clipPath: `url(#${displayerKey}clip-top)`, children: _jsx("path", { className: "line", stroke: spectrum.display.color, fill: "none", strokeWidth: "1px", d: paths }) })] }));
}
export default memo(Top1DChart);
